import { BodySmall } from 'components/Text/BodySmall';
import { MainChartDetails } from 'modules/salaries/components/MainChartDetails/MainChartDetails';
import { MainChartData } from 'modules/salaries/types/MainChartData';

import { FooterContainer, FooterLink } from './MainChartFooter.styled';

type Props = {
  data: MainChartData;
  initialized: boolean;
  loading: boolean;
};

export function MainChartFooter({ data, initialized, loading }: Props) {
  return (
    <FooterContainer $initialized={initialized} $loading={loading}>
      {!initialized || (!loading && data === null) || loading ? (
        <BodySmall textAlign="center">
          <FooterLink href={getText('/survey/faq')}>
            {getText('See our FAQ for more information on our data')}
          </FooterLink>
        </BodySmall>
      ) : (
        <MainChartDetails data={data} />
      )}
    </FooterContainer>
  );
}
